module.exports = {
  "country": "PL",
  "artist": "Edyta Góniak",
  "song": "To nie ja!",
  "year": "1994",
  "place": "2",
  "spotify": "5zuDr7y3zJXbWrGoxzXPGR"
};